// @ts-nocheck -- ported from the first version; pure string building
// The household companion (dust bunny, fox, cat, pup, chick or sprout), drawn as SVG. Its face follows the house mood and
// it grows (and eventually gets a crown) as the household earns XP.

function fluffyPath(cx, cy, rx, ry, bumps, amp) {
  let d = '';
  for (let i = 0; i <= bumps; i++) {
    const a = (i / bumps) * Math.PI * 2;
    const x = cx + rx * Math.cos(a);
    const y = cy + ry * Math.sin(a);
    if (i === 0) {
      d += `M${x.toFixed(1)},${y.toFixed(1)}`;
    } else {
      const m = ((i - 0.5) / bumps) * Math.PI * 2;
      const qx = cx + (rx + amp) * Math.cos(m);
      const qy = cy + (ry + amp) * Math.sin(m);
      d += ` Q${qx.toFixed(1)},${qy.toFixed(1)} ${x.toFixed(1)},${y.toFixed(1)}`;
    }
  }
  return `${d}Z`;
}

const FACES = {
  thriving: `
    <path d="M78 104 q8 -10 16 0" class="pet-line"/>
    <path d="M106 104 q8 -10 16 0" class="pet-line"/>
    <path d="M86 122 q14 16 28 0 z" class="pet-mouth"/>`,
  happy: `
    <circle cx="86" cy="104" r="7" class="pet-eye"/><circle cx="88.5" cy="101.5" r="2.4" class="pet-shine"/>
    <circle cx="114" cy="104" r="7" class="pet-eye"/><circle cx="116.5" cy="101.5" r="2.4" class="pet-shine"/>
    <path d="M90 122 q10 9 20 0" class="pet-line"/>`,
  meh: `
    <path d="M79 104 h14" class="pet-line"/><path d="M107 104 h14" class="pet-line"/>
    <circle cx="86" cy="108" r="4" class="pet-eye"/><circle cx="114" cy="108" r="4" class="pet-eye"/>
    <path d="M92 125 h16" class="pet-line"/>`,
  grumpy: `
    <path d="M78 96 l14 5" class="pet-line"/><path d="M122 96 l-14 5" class="pet-line"/>
    <circle cx="86" cy="107" r="5" class="pet-eye"/><circle cx="114" cy="107" r="5" class="pet-eye"/>
    <path d="M90 128 q10 -8 20 0" class="pet-line"/>`,
  sad: `
    <path d="M80 100 l10 8 M90 100 l-10 8" class="pet-line"/>
    <path d="M110 100 l10 8 M120 100 l-10 8" class="pet-line"/>
    <path d="M88 127 q4 -4 8 0 q4 4 8 0 q4 -4 8 0" class="pet-line"/>
    <path d="M123 112 q3 6 0 9 q-3 -3 0 -9z" class="pet-tear"/>`,
};

const EXTRAS = {
  thriving: `
    <path d="M40 40 q3 12 14 14 q-11 2 -14 14 q-3 -12 -14 -14 q11 -2 14 -14z" class="pet-sparkle"/>
    <path d="M160 64 q2 8 9 9 q-7 1 -9 9 q-2 -8 -9 -9 q7 -1 9 -9z" class="pet-sparkle s2"/>`,
  grumpy: `
    <circle cx="40" cy="160" r="4" class="pet-dust"/><circle cx="160" cy="150" r="3" class="pet-dust"/>`,
  sad: `
    <circle cx="36" cy="160" r="6" class="pet-dust"/><circle cx="52" cy="168" r="4" class="pet-dust"/>
    <circle cx="160" cy="158" r="7" class="pet-dust"/><circle cx="148" cy="170" r="4" class="pet-dust"/>
    <circle cx="100" cy="176" r="5" class="pet-dust"/>`,
};

const CROWN = `<path d="M80 38 l8 14 l12 -16 l12 16 l8 -14 l-4 24 h-32 z" class="pet-crown"/>`;
const CHEEKS = `<ellipse cx="72" cy="118" rx="8" ry="5" class="pet-cheek"/><ellipse cx="128" cy="118" rx="8" ry="5" class="pet-cheek"/>`;

// Each companion: its colours, what goes behind the body (ears, tail), the body, and what goes on top.
const KINDS = {
  bunny: {
    colors: '',
    back: () => `
      <path d="${fluffyPath(76, 52, 11, 28, 10, 3)}" class="pet-fur" transform="rotate(-14 76 52)"/>
      <path d="${fluffyPath(124, 52, 11, 28, 10, 3)}" class="pet-fur" transform="rotate(14 124 52)"/>
      <ellipse cx="76" cy="54" rx="5" ry="16" class="pet-ear-inner" transform="rotate(-14 76 54)"/>
      <ellipse cx="124" cy="54" rx="5" ry="16" class="pet-ear-inner" transform="rotate(14 124 54)"/>`,
    body: () => `<path d="${fluffyPath(100, 112, 58, 50, 22, 6)}" class="pet-fur"/>`,
    front: '',
  },
  fox: {
    colors: '--pet-fur:#f5a45d;--pet-stroke:#c46a2a;',
    back: () => `
      <path d="M148 150 q42 -4 32 -52" class="pet-tail pet-tail-bushy"/>
      <circle cx="180" cy="98" r="10" class="pet-white"/>
      <path d="M52 90 l12 -54 l34 34 z" class="pet-fur"/><path d="M148 90 l-12 -54 l-34 34 z" class="pet-fur"/>
      <path d="M59 58 l5 -22 l10 10 z" class="pet-ear-tip"/><path d="M141 58 l-5 -22 l-10 10 z" class="pet-ear-tip"/>`,
    body: () => `<ellipse cx="100" cy="114" rx="58" ry="50" class="pet-fur"/>`,
    front: `<ellipse cx="100" cy="128" rx="22" ry="15" class="pet-white"/><ellipse cx="100" cy="116" rx="5.5" ry="4" class="pet-nose"/>`,
  },
  cat: {
    colors: '--pet-fur:#f7cf9f;--pet-stroke:#cf9255;',
    back: () => `
      <path d="M150 150 q38 -6 26 -48" class="pet-tail"/>
      <path d="M54 88 l10 -46 l34 30 z" class="pet-fur"/><path d="M146 88 l-10 -46 l-34 30 z" class="pet-fur"/>
      <path d="M64 78 l5 -24 l17 16 z" class="pet-ear-inner"/><path d="M136 78 l-5 -24 l-17 16 z" class="pet-ear-inner"/>`,
    body: () => `<ellipse cx="100" cy="114" rx="58" ry="50" class="pet-fur"/>
      <path d="M92 70 q8 8 16 0 M84 76 q16 12 32 0" class="pet-stripe"/>`,
    front: `<path d="M66 116 l-24 -5 M66 122 l-24 3 M134 116 l24 -5 M134 122 l24 3" class="pet-whisker"/>`,
  },
  pup: {
    colors: '--pet-fur:#ecd9bc;--pet-stroke:#b98f60;',
    back: () => `<path d="M146 150 q24 -4 22 -26" class="pet-tail"/>`,
    body: () => `<ellipse cx="100" cy="114" rx="58" ry="50" class="pet-fur"/>
      <ellipse cx="116" cy="92" rx="14" ry="11" class="pet-patch"/>`,
    front: `
      <ellipse cx="50" cy="98" rx="14" ry="30" class="pet-ear-dark" transform="rotate(18 50 98)"/>
      <ellipse cx="150" cy="98" rx="14" ry="30" class="pet-ear-dark" transform="rotate(-18 150 98)"/>
      <ellipse cx="100" cy="115" rx="6" ry="4.5" class="pet-nose"/>`,
  },
  chick: {
    colors: '--pet-fur:#ffe07a;--pet-stroke:#d9a62a;',
    back: () => `
      <ellipse cx="46" cy="122" rx="12" ry="20" class="pet-fur" transform="rotate(28 46 122)"/>
      <ellipse cx="154" cy="122" rx="12" ry="20" class="pet-fur" transform="rotate(-28 154 122)"/>`,
    body: () => `<ellipse cx="100" cy="112" rx="56" ry="54" class="pet-fur"/>
      <path d="M100 60 q-4 -16 6 -22 M100 60 q6 -12 16 -12 M100 60 q-10 -8 -16 -2" class="pet-tuft"/>`,
    front: `<path d="M93 113 l7 -6 l7 6 l-7 5 z" class="pet-beak"/>`,
  },
  sprout: {
    colors: '--pet-fur:#cdeab5;--pet-stroke:#6fa557;',
    back: () => `
      <path d="M100 66 q0 -14 2 -22" class="pet-stem"/>
      <path d="M102 46 q-30 -20 -40 2 q22 12 40 -2 z" class="pet-leaf"/>
      <path d="M102 44 q26 -26 42 -6 q-20 16 -42 6 z" class="pet-leaf"/>`,
    body: () => `<path d="M42 116 q0 -52 58 -52 q58 0 58 52 q0 48 -58 48 q-58 0 -58 -48 z" class="pet-fur"/>`,
    front: '',
  },
};

export const PET_KINDS = Object.keys(KINDS);

// Things to wear, drawn over the body. One per slot: head, face, neck, body, hand.
const ITEMS = {
  bow: `<g class="it-bow"><path d="M128 66 l-14 -9 v18 z M128 66 l14 -9 v18 z"/><circle cx="128" cy="66" r="4.5"/></g>`,
  flower: `<g class="it-flower">${[0, 72, 144, 216, 288].map((a) => `<circle cx="${(72 + 7 * Math.cos((a * Math.PI) / 180)).toFixed(1)}" cy="${(68 + 7 * Math.sin((a * Math.PI) / 180)).toFixed(1)}" r="5.5"/>`).join('')}<circle cx="72" cy="68" r="4" class="it-flower-mid"/></g>`,
  beanie: `<g class="it-beanie"><path d="M56 84 q2 -40 44 -42 q42 2 44 42 z"/><rect x="52" y="78" width="96" height="12" rx="6" class="it-beanie-band"/><circle cx="100" cy="40" r="8" class="it-beanie-pom"/></g>`,
  party_hat: `<g class="it-party"><path d="M80 72 L100 22 L120 72 Z"/><path d="M88 52 l24 0 M84 62 l32 0" class="it-party-stripe"/><circle cx="100" cy="22" r="5" class="it-party-pom"/></g>`,
  sunhat: `<g class="it-sunhat"><ellipse cx="100" cy="68" rx="64" ry="11"/><path d="M68 66 q2 -30 32 -30 q30 0 32 30 z"/><path d="M69 60 q31 8 62 0" class="it-sunhat-band"/></g>`,
  glasses: `<g class="it-glasses"><circle cx="86" cy="104" r="11"/><circle cx="114" cy="104" r="11"/><path d="M97 103 h6 M75 102 l-10 -3 M125 102 l10 -3"/></g>`,
  sunglasses: `<g class="it-sunglasses"><rect x="73" y="96" width="24" height="15" rx="6"/><rect x="103" y="96" width="24" height="15" rx="6"/><path d="M97 101 h6 M73 100 l-8 -3 M127 100 l8 -3" class="it-sunglasses-frame"/></g>`,
  scarf: `<g class="it-scarf"><path d="M50 136 q50 18 100 0 l2 12 q-52 20 -104 0 z"/><path d="M128 146 l8 26 l-12 2 l-6 -24 z"/></g>`,
  bikini: `<g class="it-bikini"><path d="M76 146 q22 -5 48 0" class="it-bikini-string"/><path d="M77 145 h19 l-9 12 z M104 145 h19 l-10 12 z"/><path d="M82 160 q18 6 36 0 l-3 5 q-15 5 -30 0 z"/></g>`,
  broom: `<g class="it-broom"><path d="M146 86 L162 150" class="it-broom-stick"/><path d="M152 146 l20 -5 l8 26 q-14 6 -24 4 z"/></g>`,
};
const HEAD_ITEMS = new Set(['bow', 'flower', 'beanie', 'party_hat', 'sunhat']);

export function petSvg(pet, { size = 180 } = {}) {
  const mood = pet.mood.id;
  const kind = KINDS[pet.kind] ?? KINDS.bunny;
  // A head item replaces the crown; everything else is layered on top.
  const outfit = Object.fromEntries(Object.entries(pet.outfit ?? {}).filter(([slot, id]) => ITEMS[id] && (slot !== 'head' || HEAD_ITEMS.has(id))));
  return `
  <svg class="pet pet-${mood}" viewBox="0 0 200 200" width="${size}" height="${size}" aria-hidden="true" style="${kind.colors}">
    ${EXTRAS[mood] ?? ''}
    <g class="pet-body-group" style="transform: scale(${pet.size}); transform-origin: 100px 170px;">
      <ellipse cx="100" cy="168" rx="48" ry="7" class="pet-shadow"/>
      ${kind.back()}
      ${kind.body()}
      ${CHEEKS}
      ${kind.front}
      ${FACES[mood]}
      ${outfit.body ? ITEMS[outfit.body] ?? '' : ''}
      ${outfit.neck ? ITEMS[outfit.neck] ?? '' : ''}
      ${outfit.face ? ITEMS[outfit.face] ?? '' : ''}
      ${outfit.hand ? ITEMS[outfit.hand] ?? '' : ''}
      ${outfit.head ? ITEMS[outfit.head] ?? '' : pet.crown ? CROWN : ''}
    </g>
  </svg>`;
}
